const glideInstances = {};

const setActiveSwatch = (e) => {
  const productId = e.getAttribute("data-swatch-product-id");
  const currentProductSwatches = Array.from(
    document.querySelectorAll(`.color-swatch-${productId}`)
  );
  currentProductSwatches.map((swatch) =>
    swatch.parentElement.classList.remove("color_swatch-active")
  );
  e.parentElement.classList.add("color_swatch-active");
};

const onProductCardSwatchClick = (e) => {
  const productSizes = JSON.parse(e.getAttribute("data-swatch-product-sizes"));
  const productId = e.getAttribute("data-swatch-product-id");
  const productColor = e.getAttribute("data-swatch-product-color");
  const productImagesSource = JSON.parse(
    e.getAttribute("data-swatch-product-image")
  );
  const productUrl = e.getAttribute("data-swatch-product-url");

  const productColorLabel = document.querySelectorAll(
    `.color-swatch_label-${productId}`
  );
  const productImages = document.querySelectorAll(
    `.product-image-${productId}`
  );
  const productSizeChart = document.querySelector(
    `.size-variants_wrapper-${productId}`
  );
  const productAnchors = Array.from(
    document.querySelectorAll(`.product_card_link-${productId}`)
  );
  const productImagesContainer = document.querySelector(
    `.product_card_slides-${productId}`
  );

  const bulletContainer = document.querySelector(
    `.bullet-container-${productId}`
  );

  const totalNumberOfSlides = productImagesSource.length;

  const imageWidth = productImages[0].getBoundingClientRect().width;

  const slidesContainerWidth = totalNumberOfSlides * imageWidth + "px";

  setActiveSwatch(e);

  const updatedProductImages = productImagesSource
    .map(
      (image) =>
        ` <image-with-placeholder class="relative" style="width: ${imageWidth}px ; margin-right: 0px;">
            <img src="/cdn/shop/files/P1161_8.jpg?v=1723620006&amp;width=3000" alt="האוורירית-פסים שרוול קצר" srcset="${image}" width="3000" height="4500" loading="loading" class="peer/image product-image-7469126779089 is-complete" sizes="(min-width: 1024px) calc(100vw / 12 * 4), 50vw">
            <div class="absolute inset-0 h-full w-full bg-scheme-text opacity-[0.05] peer-[.is-complete]/image:opacity-0 no-js:hidden"></div>
          </image-with-placeholder>
        `
    )
    .join("");

  const bullets = productImagesSource
    .map(
      (image, index) =>
        `<button class="glide__bullet" data-glide-dir="=${index}"></button>`
    )
    .join("");

  if (bulletContainer) {
    bulletContainer.innerHTML = bullets;
  }

  productImagesContainer.innerHTML = updatedProductImages;

  productColorLabel.forEach((label) => {
    label.innerHTML = productColor;
  });

  const updatedSizes = productSizes
    .map((size) => {
      const isAvailable =
        size.available === "true" ? "" : "size-variant_unavailable";
      return `
            <div class="px-1 size-variant_b-plan relative ${isAvailable}">
            <p>${size.size}</p>
            </div>
        `;
    })
    .join("");

  productSizeChart.innerHTML = updatedSizes;

  productAnchors.map((productAnchor) => (productAnchor.href = productUrl));

  productImagesContainer.style.width = slidesContainerWidth;

  if (glideInstances[productId]) {
    glideInstances[productId].destroy();
  }

  const glide = new Glide(`.product-card-slider-${productId}`, {
    type: "slider",
    perView: 1,
    gap: 0,
  });

  glide.mount();

  glideInstances[productId] = glide;
};

const onProductDetailSwatchClick = (e) => {
  setActiveSwatch(e);
  const productUrl = e.getAttribute("data-swatch-product-url");
  if (productUrl) {
    // Navigate to the product URL
    window.location.href = productUrl; // or window.location.assign(productUrl);
  } else {
    console.error("Product URL not found!");
  }
};

const enableSlider = () => {
  if (document.querySelectorAll(`.product-card-slider`)) {
    document.querySelectorAll(".preloader_glide").forEach((loader) => {
      loader.classList.add("hidden");
    });
    document.querySelectorAll(".product-card-slider").forEach((slider) => {
      slider.classList.remove("hidden");
      const id = slider.getAttribute("data-product-id");

      const glide = new Glide(slider, {
        type: "slider",
        perView: 1,
        gap: 0,
      });

      glide.mount();

      // const images = Array.from(
      //   slider.querySelector(".product_card_slides").children
      // );
      // console.log(images);

      // const bulletContainer = slider.querySelector(".bullet-container");

      // console.log(bulletContainer);

      // const bullets = images
      //   .map((image, index) => {
      //     console.log(index);
      //     return `<button class="glide__bullet" data-glide-dir="=${index}"></button>`;
      //   })
      //   .join("");

      // bulletContainer.innerHTML = bullets;

      glideInstances[id] = glide;
    });
  }
};


const filtersWrapper = document.querySelector('.filters-wrapper');

console.log(filtersWrapper)

const observer = new MutationObserver(function(mutationsList, observer) {
  enableSlider();
});

const config = {
  childList: false,  
  subtree: false, 
  attributes: true 
};

if(filtersWrapper){
  observer.observe(filtersWrapper, config);
}

enableSlider();
